export const EMPTY_CELL_VALUE = '-';

export default EMPTY_CELL_VALUE;
